import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "dashed"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { Divider } from 'rc-menu';
import { usePrefixCls } from '../../../config/hooks/usePrefixCls';
import { classnames } from '../../../utils';
var MenuDivider = function MenuDivider(_ref) {
  var className = _ref.className,
    dashed = _ref.dashed,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var cls = classnames(usePrefixCls('menu', {
    'item-divider-dashed': !!dashed
  }), className);
  return React.createElement(Divider, _objectSpread({
    className: cls
  }, restProps));
};
export default MenuDivider;